import { BadgeCheck, Hourglass, Pencil, ShieldCheck } from 'lucide-react';
import React from 'react';

import { type SsoConnection } from '@column/api';
import { Button } from '@column/ui';

import { StatusBadge } from '~/components/Table';
import { SelectedCard } from '~/lib/components/selectors/primitives';
import { formatDateTime } from '~/util';

import { CONNECTION_ICON_BUTTON_CLASS_NAME } from './constants';
import { ModeBadge } from './ModeBadge';

export const ConnectionCard: React.FC<{
  connection: SsoConnection;
  onEdit: () => void;
}> = ({ connection, onEdit }) => (
  <SelectedCard
    open
    title={
      <span className="flex min-w-0 items-center gap-2">
        <span className="truncate">{connection.display_name}</span>
        <ModeBadge mode={connection.mode} />
      </span>
    }
    icon={<ShieldCheck className="size-5" />}
    actions={
      <Button
        type="button"
        variant="muted"
        size="icon-sm"
        aria-label={`Edit ${connection.display_name}`}
        onClick={onEdit}
        className={CONNECTION_ICON_BUTTON_CLASS_NAME}
      >
        <Pencil />
      </Button>
    }
    rows={[
      { label: 'Created', value: formatDateTime(new Date(connection.created_at), { timeZoneFormat: 'local' }) },
      { label: 'Issuer', value: connection.issuer },
      { label: 'Client ID', value: connection.client_id, monospaced: true },
      {
        label: 'Domains',
        value:
          connection.domains.length > 0 ? (
            connection.domains.map((domain) => (
              <StatusBadge key={domain.id} tone={domain.verified_at ? 'default' : 'warning'} className="gap-0">
                {domain.verified_at ? (
                  <BadgeCheck className="mr-1 size-3.5" />
                ) : (
                  <Hourglass className="mr-1 size-3.5" />
                )}
                {domain.domain}
              </StatusBadge>
            ))
          ) : (
            <StatusBadge tone="danger">No domains linked</StatusBadge>
          ),
      },
    ]}
  />
);
